export const ddns = {
  sys_dnshost_account: "sys_dnshost",
  sys_dnsmail_account: "sys_dnsmail",
  sys_dnspassword_account: "sys_dnspassword",
  sys_dnshost: "sys_dnshost",
  sys_dnspassword: "sys_dnspassword",
  ddns_reg_agree: "ddns_reg_agree",
};

export default ddns;
